"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SandboxBackofficeAPI = exports.BackofficeAPI = exports.SandboxAPI = exports.API = void 0;
var ApiImplementation_1 = require("./ApiImplementation");
exports.API = new ApiImplementation_1.API(process.env.REACT_APP_BACKEND_BASE_URL || 'https://api.element.in', 'UNDEFINED');
exports.SandboxAPI = new ApiImplementation_1.API(process.env.REACT_APP_BACKEND_SANDBOX_BASE_URL ||
    'https://sandbox-api.element.in', 'UNDEFINED');
exports.BackofficeAPI = new ApiImplementation_1.API(process.env.REACT_APP_BACKEND_BACKOFFICE_BASE_URL ||
    'https://backoffice-api.element.in', 'FALSE');
exports.SandboxBackofficeAPI = new ApiImplementation_1.API(process.env.REACT_APP_BACKEND_BACKOFFICE_BASE_URL ||
    'https://backoffice-api.element.in', 'TRUE');
//# sourceMappingURL=API.js.map